import React from 'react'
import styles from './styles.css'
import AsyncSelect from 'react-select/lib/Async'
import useClient from 'apollo-hooks/lib/useClient'
import gql from 'graphql-tag'

export default function Place(props) {
  const client = useClient()

  const onChange = value => {
    props.onChange(value.value)
  }

  const search = async inputValue => {
    const {
      data: {places}
    } = await client.query({
      query: gql`
        query searchPlace($filter: String, $countryCode: ID) {
          places: searchPlace(filter: $filter, countryCode: $countryCode) {
            text
            secondaryText
            placeId
          }
        }
      `,
      variables: {filter: inputValue, countryCode: props.countryCode},
      fetchPolicy: 'network-only'
    })
    return places.map(place => {
      return {
        place,
        label: (
          <div className={styles.place}>
            <div className={styles.mainText}>{place.text}</div>
            <div className={styles.secondaryText}>{place.secondaryText}</div>
          </div>
        ),
        value: place.placeId
      }
    })
  }

  return (
    <div className={styles.container}>
      <div className="label">{props.label}</div>
      <AsyncSelect
        classNamePrefix="orion-select"
        placeholder="Escribe la dirección"
        onChange={onChange}
        loadOptions={search}
        isClearable
      />
      <div className="description">{props.description}</div>
      <div className="os-input-error">{props.errorMessage}</div>
    </div>
  )
}
